import {
  Component,
  Input,
  OnInit,
  AfterViewInit,
  Pipe,
  PipeTransform,
  ElementRef,
  ViewChild,
} from "@angular/core";
import { DomSanitizer } from "@angular/platform-browser";
import { ActivatedRoute, Params, Router } from "@angular/router";
import { FormArray, FormBuilder, FormGroup, Validators } from "@angular/forms";
import { AngularEditorConfig } from "@kolkov/angular-editor";
import { first } from "rxjs/operators";
import { NgbModal, NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";
import { GestionFichierService } from "src/app/core/services/business/service/gestion-fichier.service";

@Component({
  selector: "app-pdf-viewer-modal",
  templateUrl: "./pdf-viewer-modal.component.html",
  styleUrls: ["./pdf-viewer-modal.component.scss"],
})
export class PdfViewerModalComponent implements OnInit {
  url: any = null;

  destination: any = "";

  @Input() subitemId;

  progress: number = 0;

  constructor(
    private _router: Router,
    private _activatedRoute: ActivatedRoute,
    private fb: FormBuilder,
    private activeModal: NgbActiveModal,
    private sanitizer: DomSanitizer,
    private el: ElementRef,
    private _gestionFichierService: GestionFichierService
  ) {}

  transform(url) {
    return this.sanitizer.bypassSecurityTrustResourceUrl(url);
  }

  ngOnInit() {
    this.downloadFile(this.subitemId);
  }

  downloadFile(subitemId: string) {
    this._gestionFichierService.downloadFileProgress(subitemId).subscribe(({ progress, blob }) => {
      this.progress = progress;
      if (blob) {
        this.destination = blob;
        this.progress = 0; // Reset progress after download completes
      }
    }, (error) => {
      console.error('Download failed', error);
      this.progress = 0; // Reset progress on error
    });
  }

}
